import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Panel } from '@nintex-ux/react-core/dist/Panel';
import { GlobalNav } from '@nintex-ux/react-core/dist/GlobalNav';
import { Button } from '@nintex-ux/react-core/dist/Button';
import { BreadCrumbs } from '@nintex-ux/react-core/dist/BreadCrumbs';
import '@nintex-ux/icons-svg/icons/utility/chevron-right.svg';
import '@nintex-ux/icons-svg-monochrome/icons/utility/arrow-move-left.svg';
import qs from 'query-string';
import cn from 'classnames';
import SetupNwc from './SetupNwc';
import SetupNwcIntegration from './SetupNwcIntegration';

const OnBoardToNwc2 = () => {
    const { t } = useTranslation();

    const rootBreadCrumb = {
        value: t('onBoardNwc2.title'),
        clickable: true,
    };

    const history = useHistory();
    const queryString = qs.parse(history.location.search);
    const [panelTitle, setPanelTitle] = useState(t('onBoardNwc2.title'));
    const [breadCrumbs, setBreadCrumbs] = useState([rootBreadCrumb]);
    const [showIntegrationInformation, setShowIntegrationInformation] = useState(false);
    const [showBreadCrumbs, setShowBreadCrumbs] = useState(false);



    const navigateToNwcIntegration = () => {
        setPanelTitle(t('onBoardNwc2.howToIntegrateNac'));
        setShowIntegrationInformation(true);
        setShowBreadCrumbs(true);

        setBreadCrumbs([rootBreadCrumb, {
            value: t('onBoardNwc2.integrateExistingTenant'),
            clickable: false,
        }]);
    };

    const navigateToNwcTrial = () => {
        setShowIntegrationInformation(false);
        window.open('https://www.nintex.com/trial/free-trial-workflow/', '_blank');
    };

    const handleBreadcrumbClick = (e) => {
        setShowBreadCrumbs(false);
        setPanelTitle(e.value);
        setShowIntegrationInformation(false);
    }

    const listUrl = () => {
        return queryString.listUri; 
    }

    const redirectToSharePointList = () => {
        window.location.href = listUrl();
    }

    return (
        <>
            <GlobalNav />

            <div className={cn('nwc-container container-fluid')}>
                {showBreadCrumbs &&
                    <BreadCrumbs 
                        onClick={handleBreadcrumbClick}
                        crumbs={breadCrumbs}
                    />
                }

                <Panel title={panelTitle} skin="blue">
                    <Panel.Content>
                        <div>
                            {!showIntegrationInformation &&
                                <SetupNwc
                                    onNavigateToNwcIntegration={navigateToNwcIntegration}
                                    onNavigateToNwcTrial={navigateToNwcTrial}
                                />
                            }

                            {showIntegrationInformation &&
                                <SetupNwcIntegration />
                            }
                        </div>
                    </Panel.Content>
                </Panel>

                <Button
                    icon="arrow-move-left"
                    type="link"
                    link={true}
                    onClick={redirectToSharePointList}
                >
                    {t('returnToSharePoint')} 
                </Button>
            </div>
        </>
    );
}

export default OnBoardToNwc2;